import { useContext, useEffect } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
export default function UI_Input_Text_Long({
    id,
    Autoresize,
    Input_Placeholder,
    Label_Text,
    onInput,
    onChange,
    Value,
    Value_Set_Enable,
    Required
}) {
    const UI = useContext(Context_UI);
    const isControlled = Value_Set_Enable;
    useEffect(() => {
        UI.TextArea_SnapToSize(id);
    }, [Autoresize, id, UI]);
    const Handle_Input = (e) => {
        console.log(Autoresize);
        if (Autoresize === "true") {
            UI.TextArea_SnapToSize(id);
        }
        if (onChange) {
            onChange(e);
        }
        if (onInput) {
            onInput(e);
        }
        // if (onInput) {
        //     console.log("Not undefined");
        //     onInput();
        // } else {
        //     console.log("Undefined");
        // }
    };
    return (
        <>
            <label className="Input_Label" for={id}>
                {Label_Text}
                {Required ? <p className="Input_Label_Required">*</p> : ""}
            </label>
            {Autoresize == "true" ?
                <div>
                    <textarea
                        type="text"
                        id={id}
                        className="Input_Text_Long"
                        placeholder={Input_Placeholder}
                        Fill_Horizontal
                        Autoresize={Autoresize}
                        onInput={Handle_Input}
                        onChange={Handle_Input}
                        {...(isControlled ? { value: Value || "" } : { defaultValue: Value })}
                    ></textarea >
                    <p className="Input_Text_Prompt" id={`${id}_Prompt`}>

                    </p>
                </div>
                :
                <div>
                    <textarea
                        type="text"
                        id={id}
                        className="Input_Text_Long"
                        placeholder={Input_Placeholder}
                        Fill_Horizontal
                        Autoresize={Autoresize}
                        onInput={Handle_Input}
                        onChange={Handle_Input}
                        {...(isControlled ? { value: Value || "" } : { defaultValue: Value })}
                    ></textarea >
                    <p className="Input_Text_Prompt" id={`${id}_Prompt`}>
                        
                    </p>
                </div>

            }

        </>
    )
}

